module.exports = __webpack_public_path__ + "media/src/img/needhelp-cloud-90367d15d9ea6b4c21b6275eea26adf5.png";